/**
 * ISO日付文字列（"2026-07-01"）を「2026年7月」形式に整形する。
 * 記事の date はISO形式で管理し（sitemapのlastmod等に使う）、表示時のみ変換する。
 */
export function formatMonthJa(isoDate) {
  if (!isoDate) return "";
  const m = /^(\d{4})-(\d{2})/.exec(String(isoDate));
  if (!m) return String(isoDate);
  return `${m[1]}年${Number(m[2])}月`;
}

/**
 * ISO日付文字列（"2026-07-15"）を「2026.07.15」形式に整形する（お知らせ表示用）。
 */
export function formatDotDate(isoDate) {
  if (!isoDate) return "";
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(isoDate));
  if (!m) return String(isoDate);
  return `${m[1]}.${m[2]}.${m[3]}`;
}
